const ExitConfirmationHandlersManager = function() {}

/**
 * Makes browser show a confirmation message before any navigation when
 * isConfirmationOnUnloadRequired() == true
 * @param isPopupMode if isPopupMode is true, then exit confirmation will be disabled, when window.opener close
 * @param message confirmation message that will be shown when user would try to close the popup or navigate to another page
 * @param isConfirmationOnUnloadRequired a callback method that must always return true when we need to show confirmation before any navigation and false otherwise
 * */
ExitConfirmationHandlersManager.setUpExitConfirmation = function (message, isConfirmationOnUnloadRequired, isPopupMode, mustNotWarnUserIfIsNotCurrent)
{
    if (!window["exitConfirmationHandlers"])
        window["exitConfirmationHandlers"] = [];
    else if (window.onbeforeunload != null)
        window["exitConfirmationHandlers"].push( window.onbeforeunload );

    var confirmationEnabled = true;
    var confirmExit = function()
    {
        var confMessage = "";
        if ( confirmationEnabled && isConfirmationOnUnloadRequired() )
            confMessage += message;

        if ( window["exitConfirmationHandlers"] && window["exitConfirmationHandlers"].length > 0 )
        {
            for( var i = window["exitConfirmationHandlers"].length - 1; i >= 0; i-- )
            {
                var handler = window["exitConfirmationHandlers"][i];
                if( handler.mustWarnUser() )
                    confMessage += ( isNotEmpty(confMessage) ? "\n\n" : "" ) + handler.getConfirmationMessage();
            }
        }

        if (isNotEmpty(confMessage))
            return confMessage;
    };
    confirmExit.mustWarnUser = function () { return !mustNotWarnUserIfIsNotCurrent && confirmationEnabled && isConfirmationOnUnloadRequired() };
    confirmExit.getConfirmationMessage = function () { return message };

    var disableConfirmation= function()
    {
        confirmationEnabled = false;
    };

    window.onbeforeunload = confirmExit;

    //after a navigation in the parent window it would try to close all the popups
    //opened from it. In this case popups shall be closed without any confirmations
    /* TODO:
     * the call of the EventListener causes an error in FF7 if parent window needs to be reload after popup is closed.
     * confirmationEnabled and disableConfirmation should be moved outside of this function in order to allow to
     * remove EventListener from parent window before popup closes. This is required, because to remove EventListener
     * you need to specify the same function you setup as a listener
     * For more information refers to Bug 33983: FF7: JS error when Edit Open Task or Create New Tasks pop-up is closed
     */
    if (isPopupMode)
        addListener(window.opener, "beforeunload", disableConfirmation);
};

ExitConfirmationHandlersManager.restoreExitConfirmation = function ()
{
    var oldHandler;
    if ( window["exitConfirmationHandlers"] && (oldHandler = window["exitConfirmationHandlers"].pop()) )
        window.onbeforeunload = oldHandler;
    else
        window.onbeforeunload = null;
};

// if we set window.onbeforeunload = undefined, it will cause errors in IE
ExitConfirmationHandlersManager.resetExitConfirmation = function ()
{
    window.onbeforeunload  = null;
    window["exitConfirmationHandlers"] = null;
};

export default ExitConfirmationHandlersManager



// WEBPACK FOOTER //
// ./web/js/ExitConfirmationHandlersManager.js